import ctaBanner from './fieldsets/cta-banner';
import listing from './fieldsets/listing';
import mediaConfig from './fieldsets/media-config';

const fieldsetsConfig = {
    listing,
    'cta-banner': ctaBanner,
    'media-config': mediaConfig,
};

export default fieldsetsConfig;
